const initFormValidation = () => {
    const contactFormRequiredElements = document.querySelectorAll(".contact-form-section :required");
    const showErrorToRequiredElements = (arrayOfRequiredElements) => {
        arrayOfRequiredElements.forEach(function (item) {
            if (item.hasAttribute("required")) {
                item.addEventListener('keyup', function () {
                    const isValidItem = item.checkValidity();
                    if (isValidItem) {
                        item.classList.remove('error');
                    }
                    else {
                        item.classList.add('error');
                    }
                });
            }
        });
    };
    if (contactFormRequiredElements) {
        showErrorToRequiredElements(contactFormRequiredElements);
    }
};
